
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTurn as ObiTurnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-turn.js';
 
 
 

 
 export const ObiTurn = createComponent({
   react: React,
   tagName: 'obi-turn',
   elementClass: ObiTurnElement,
   events: {
     
   }
  });
 
 